import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-2 d-flex align-items-center" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { class: "ms-2" }
const _hoisted_4 = { class: "cursor-pointer open-popup-button position-absolute" }
const _hoisted_5 = { class: "link-large-underline link-default" }

import { onMounted, ref, nextTick } from "vue"
import type { Ref } from "vue"

// Classe
import TextShowMoreLess from "@/textShowMoreLess/textShowMoreLess"
import { ClubAdvantage } from "@/vue/club-advantages/classes/ClubAdvantage"

// Components
import PopupBase from "@/vue/common/popupBase.vue"

// Max lines
const MAX_LINES = 5

// Content

export default /*@__PURE__*/_defineComponent({
  __name: 'ClubServiceCard',
  props: {
    refName: {},
    advantage: {}
  },
  setup(__props: any) {

const content: any = (window as any).content
const contentWrapper = ref<HTMLElement|null>(null)

// Props
const props = __props

// Refs
const restauration = ref(null)
const animation = ref(null)
const wellBeing = ref(null)
const InfantClub = ref(null)
const isPopUpOpen = ref(false)


// Methods

function handleOpenPopUp() { isPopUpOpen.value = true }
function handleClosePopUp() { isPopUpOpen.value = false }

const initTextShowMoreLess = (): void => {
	if (restauration.value) {
		const restaurationTextShowMoreLess = new TextShowMoreLess(
			restauration.value,
			MAX_LINES
		)
		restaurationTextShowMoreLess.init()
	}
	if (animation.value) {
		const animationTextShowMoreLess = new TextShowMoreLess(
			animation.value,
			MAX_LINES
		)
		animationTextShowMoreLess.init()
	}
	if (wellBeing.value) {
		const wellBeingTextShowMoreLess = new TextShowMoreLess(
			wellBeing.value,
			MAX_LINES
		)
		wellBeingTextShowMoreLess.init()
	}
	if (InfantClub.value) {
		const InfantClubTextShowMoreLess = new TextShowMoreLess(
			InfantClub.value,
			MAX_LINES
		)
		InfantClubTextShowMoreLess.init()
	}
}

onMounted(async() => {
	await nextTick()
	if (contentWrapper.value) {
		new TextShowMoreLess(contentWrapper.value, MAX_LINES).init()
	}
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "service-card shadow-3 position-relative cursor-pointer",
    onClick: handleOpenPopUp
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, [
        _renderSlot(_ctx.$slots, "icon")
      ]),
      _createElementVNode("span", _hoisted_3, [
        _renderSlot(_ctx.$slots, "title")
      ])
    ]),
    _createElementVNode("div", {
      ref_key: "contentWrapper",
      ref: contentWrapper,
      class: "card-content position-relative show-more-less-text"
    }, [
      _renderSlot(_ctx.$slots, "content")
    ], 512),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("u", _hoisted_5, _toDisplayString(_unref(content).planner_prestationsMoreInfo), 1),
      _cache[0] || (_cache[0] = _createElementVNode("svg", {
        color: "var(--primary-blue)",
        width: "10",
        height: "10",
        class: "icon"
      }, [
        _createElementVNode("use", { href: "#___icon___chevron-right-bold" })
      ], -1))
    ]),
    (_ctx.advantage.popUpComponent)
      ? (_openBlock(), _createBlock(PopupBase, {
          key: 0,
          open: isPopUpOpen.value,
          onClosePopup: handleClosePopUp
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.advantage.popUpComponent), {
              onClosePopup: handleClosePopUp,
              advantage: props.advantage
            }, null, 40, ["advantage"]))
          ]),
          _: 1
        }, 8, ["open"]))
      : _createCommentVNode("", true)
  ]))
}
}

})